import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Card } from '@gogoair/ba-ui-kit';
import Footer from '../../components/Footer';

import './index.scss';
import { apiGetPresignedUrl, apiGetVisionCatalogPresignedUrl } from './actions';

interface HelpProps {
  isAuthenticated: boolean;
  isInternal?: boolean;
  selectedAccountId?: string | null;
}

const Help = ({ isAuthenticated, isInternal, selectedAccountId }: HelpProps): JSX.Element => {
  const [reguMatrixLink, setRegMatrixLink] = useState<string | undefined>(undefined);
  const [instructionLink, setInstructionLink] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }
    // initialize regulatory matrix
    apiGetPresignedUrl().then(res => {
      setRegMatrixLink(res);
    });

    // refresh the link every 14 minutes (each signed link only valid for 15 minutes)
    const interval = setInterval(() => {
      apiGetPresignedUrl().then(res => {
        setRegMatrixLink(res);
      });
    }, 14 * 60 * 1000);

    return () => clearInterval(interval);
  }, [isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }
    // initialize vision catalog. Links last 7 days so no need to refresh them.
    apiGetVisionCatalogPresignedUrl().then(res => {
      if (res.status === 200 && res.results) {
        setInstructionLink(res.results['index.html']);
      }
    });
  }, [isAuthenticated]);

  return (
    <div className="contact" data-test="contact">
      <div className="content">
        <Grid>
          <Card>
            <span data-test="gogo-tech-support">
              <div className="ui-panelrow">
                <h3 className="title">Gogo DASH</h3>
              </div>
              {isAuthenticated ? (
                <React.Fragment>
                  {selectedAccountId || isInternal ? (
                    <div className="ui-panelrow">
                      View our <Link to="/notes">Release Notes</Link>
                    </div>
                  ) : (
                    <div className="ui-panelrow">
                      You may view release notes here once you have selected an account.
                    </div>
                  )}
                  <div className="ui-panelrow">
                    For help first try reading through the{' '}
                    <a
                      href="https://business.gogoair.com/support/product-documentation/dash-how-to"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Gogo DASH User Guide
                    </a>
                  </div>
                  <div className="ui-panelrow">
                    For additional assistance please contact{' '}
                    <a
                      href="https://www.gogoair.com/about/contact-us/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Gogo
                    </a>
                  </div>
                  <div className="ui-panelrow">
                    For technical resources visit{' '}
                    <a
                      href="https://techpubs.gogoair.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Techpubs
                    </a>
                  </div>
                  {reguMatrixLink && (
                    <div className="ui-panelrow">
                      View the Galileo{' '}
                      <a href={reguMatrixLink} target="_blank" rel="noopener noreferrer" download>
                        Regulatory Matrix
                      </a>
                    </div>
                  )}
                  {instructionLink && (
                    <div className="ui-panelrow">
                      Vision Catalog{' '}
                      <a href={instructionLink} target="_blank" rel="noopener noreferrer">
                        Download
                      </a>
                    </div>
                  )}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="ui-panelrow">
                    Gogo DASH is a powerful addition to your Gogo wireless service.
                  </div>
                  <div className="ui-panelrow">
                    To sign up for Gogo DASH please contact{' '}
                    <a
                      href="https://www.gogoair.com/solutions/flight-operations#dash"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Gogo
                    </a>
                    .
                  </div>
                </React.Fragment>
              )}
            </span>
          </Card>
        </Grid>
      </div>
      <Footer />
    </div>
  );
};

export default Help;
